module.exports = __webpack_public_path__ + "img/12.465e1917.jpg";